<template>
  <b-container fluid>
    <backlink/>
    <h1>Zones de stockage</h1>

    <AdminTable :config="config" :options="options"></AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTable";
import config from "./config";

export default {
  name: "StorageZoneList",
  components: {
    AdminTable
  },
  data() {
    return {
      config: config
    };
  },
  computed: {
    options: function() {
      return {
        warehouse_options: this.$store.getters["warehouse/getAll"].selectOptions("id", ["internal_code", " - ", "name"])
      };
    }
  },
  mounted() {
    this.$store.dispatch("warehouse/getAll");
  }
};
</script>


// WEBPACK FOOTER //
// src/components/StorageZone/StorageZoneList.vue